module.exports = "pegasus_template/assets/themecapture1/creative/102.png";